import { render, staticRenderFns } from "./TitlePurchase.vue?vue&type=template&id=70cf2ca4&scoped=true&"
import script from "./TitlePurchase.vue?vue&type=script&lang=js&"
export * from "./TitlePurchase.vue?vue&type=script&lang=js&"
import style0 from "./TitlePurchase.vue?vue&type=style&index=0&id=70cf2ca4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cf2ca4",
  null
  
)

export default component.exports